import ApiConnection from "./connection";

const getTimeLineStep = async ({ token, username, cod_event, cod_request }) => {
  try {
    const response = await ApiConnection.post(
      "/timeline/get-timeline-step",
      { username: username, cod_event: cod_event, cod_request: cod_request },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response.data;
  } catch (error) {
    // Captura a mensagem de erro e a retorna para a interface
    if (error.response && error.response.data && error.response.data.message) {
      return error.response.data.message; // Retorna a mensagem de erro
    }
    return "Erro desconhecido. Tente novamente mais tarde."; // Caso não tenha erro esperado
  }
};

export default function timeline() {
  return {
    getTimeLineStep,
  };
}
